import asTimeRange from '@/filters/asTimeRange';

export default {
    filters: {
        asTimeRange,
    },
    methods: {
        isOpenOn(d) {
            const date = this.getDateObjectFrom(d),
                day = this.studio.operating_hours[date.weekdayLong.toLocaleLowerCase()],
                exception = this.studio.operating_hours.exceptions[date.toISODate()],
                isNormalDay = !(!day || day.length === 0),
                isHoliday = exception && exception.hours && exception.hours.length === 0,
                isException = exception && exception.hours && exception.hours.length > 0;

            return (isNormalDay && !isHoliday) || isException;
        },
        parseOperatingHours(hoursString) {
            const [open, close] = hoursString.split('-'),
                [openHour, openMinute] = open.split(':'),
                [closeHour, closeMinute] = close.split(':');

            return [openHour, openMinute, closeHour, closeMinute];
        },
        getOperatingHoursForDate(d) {
            if (!this.isOpenOn(d)) {
                return '';
            }

            const date = this.getDateObjectFrom(d),
                day = this.studio.operating_hours[date.weekdayLong.toLocaleLowerCase()],
                exception = this.studio.operating_hours.exceptions[date.toISODate()];

            if (day && day.hours) {
                return day.hours;
            }

            if (exception && exception.hours) {
                return exception.hours;
            }

            return '';
        },
        parseOperatingHoursForDate(d) {
            const date = this.getDateObjectFrom(d),
                hours = this.getOperatingHoursForDate(d),
                [openHour, openMinute, closeHour, closeMinute] = this.parseOperatingHours(hours[0]),
                open = date.set({ hour: openHour, minute: openMinute }),
                close = date.set({ hour: closeHour, minute: closeMinute });

            return [open, close];
        },
        displayOperatingHoursForDate(d) {
            return this.$options.filters.asTimeRange(...this.parseOperatingHoursForDate(d));
        },
    },
};
